import React, { useState } from 'react';
import Header from 'on_web/components/shared/Menu/Header/Header';
import StickyNavigation from 'on_web/components/shared/Common/StickyNavigation/StickyNavigation';

import PceStepProgressIndicator from 'on_web/components/shared/PceStepProgressIndicator/PceStepProgressIndicator';
import Question from 'on_web/components/shared/Question/Question';
import UserProfileContext from 'on_web/context/userProfileContext';

import { useTranslation } from 'react-i18next';

export default function SkinCareStep5(props) {
  const context = React.useContext(UserProfileContext);

  const [
    selectedSensitiveOrIrritated,
    setSelectedSensitiveOrIrritated,
  ] = useState(
    context &&
      context.userMetaData &&
      context.userMetaData.pceSensitiveOrIrritatedSkin
      ? context.userMetaData.pceSensitiveOrIrritatedSkin
      : undefined
  );
  const [
    selectedLikeScentedProducts,
    setSelectedLikeScentedProducts,
  ] = useState(
    context &&
      context.userMetaData &&
      context.userMetaData.pceLikeScentedProducts
      ? context.userMetaData.pceLikeScentedProducts
      : undefined
  );

  const { t } = useTranslation();

  const onClickNext = () => {
    const userMetadata = context ? context.userMetaData : null;

    if (props.onClickNext && userMetadata) {
      userMetadata.pceSensitiveOrIrritatedSkin = selectedSensitiveOrIrritated;
      userMetadata.pceLikeScentedProducts = selectedLikeScentedProducts;
      props.onClickNext(userMetadata);
    }
  };

  const questions1 = [
    {
      checked: selectedSensitiveOrIrritated === '1',
      value: '1',
      label: t('common.answers.answerYes'),
    },
    {
      checked: selectedSensitiveOrIrritated === '2',
      value: '2',
      label: t('common.answers.answerNo'),
    },
  ];

  const questions2 = [
    {
      checked: selectedLikeScentedProducts === '1',
      value: '1',
      label: t('common.answers.answerYes'),
    },
    {
      checked: selectedLikeScentedProducts === '2',
      value: '2',
      label: t('common.answers.answerNo'),
    },
  ];

  return (
    <React.Fragment>
      <Header />
      <PceStepProgressIndicator selectedSlideIx={2} />

      <Question
        sectionTitle={t(
          'pceOnboarding.skinCareSection.skinCareStep5.sectionTitle1'
        )}
        radioSelection={{ items: questions1, twoColumns: true }}
        onAnswer={val => setSelectedSensitiveOrIrritated(val)}
      />

      <Question
        sectionTitle={t(
          'pceOnboarding.skinCareSection.skinCareStep5.sectionTitle2'
        )}
        radioSelection={{ items: questions2, twoColumns: true }}
        onAnswer={val => setSelectedLikeScentedProducts(val)}
      />

      <StickyNavigation
        onClickNext={() => onClickNext()}
        onClickBack={props.onClickBack}
        nextButtonDisabled={
          selectedSensitiveOrIrritated == null ||
          selectedLikeScentedProducts == null
        }
      />
    </React.Fragment>
  );
}
